import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

type MatDataType = {
  luminous :string;
  shipstation :string;
};

@Component({
  selector: 'lum-picklist-packing-hold-order-popup-success',
  templateUrl: './picklist-packing-hold-order-popup-success.component.html',
  styleUrls: ['./picklist-packing-hold-order-popup-success.component.scss'],
})
export class PicklistPackingHoldOrderPopupSuccessComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data :MatDataType) {}
}
